import { useState } from "react"

export const VariableAnthoreTask = () => {
    const [state, setState] = useState({
        description:"",
        Load: false,
        address :'',
        lat :'',
        lng :'',
        // city_id :'',
        // target_group_id :'',
        report_type_id :'',
        medical_rep_id :"",
        time :'',
        date :'',
        status: "not_done",
        // priority_level :'',
        work_plan_id :'',


    })
    const setLoad = (value) => {
        setState((prevState) => ({
            ...prevState,
            Load: value,
        }));
    };
    const handleChangeTask = (value, variableName) => {
        setState((prevState) => ({
            ...prevState,
            [variableName]: value,
        }));
    };
    return {
        ...state , 
        state , 
        setState,
        handleChangeTask,
        setLoad
    }
}